module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-check-353781d3.svg";